import React, { useState } from "react";
import { Input } from "./ui/input";
import { Eye, EyeOff } from "lucide-react";

export function PasswordInput({ value, onChange, placeholder, testid, className, required, id }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        id={id}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`pr-10 ${className || ""}`}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? "Sembunyikan password" : "Lihat password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-gtsnavy transition-colors"
        data-testid={testid ? `${testid}-toggle` : undefined}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
